import { render, staticRenderFns } from "./TurndownReasonField.vue?vue&type=template&id=636f97b8"
import script from "./TurndownReasonField.vue?vue&type=script&lang=js"
export * from "./TurndownReasonField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports